import { useEffect, useState } from "react";
import axios from "axios";
import { API, BUSINESS } from "@/lib/api";
import { imgUrl } from "@/components/site/WorkGallery";
import { ShareButtons } from "@/components/site/ShareButtons";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export const Specials = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    axios.get(`${API}/gallery?category=special`).then((r) => setItems(r.data)).catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section id="specials" className="bg-[#0E1F3F] py-16 text-white sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <div className="mb-10 flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="eyebrow mb-3 !text-[#F2B91C]">Specials &amp; services</p>
            <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">What we're working on this season.</h2>
          </div>
          <a href={BUSINESS.phoneHref} className="text-sm font-semibold text-[#F2B91C]" data-testid="specials-call-link">Call or text {BUSINESS.phone} →</a>
        </div>
        <div className="flex snap-x gap-6 overflow-x-auto pb-4">
          {items.map((i) => (
            <figure key={i.id} data-testid={`special-item-${i.id}`} className="w-72 shrink-0 snap-start sm:w-80">
              <button onClick={() => setOpen(i)} className="block overflow-hidden rounded-xl border border-white/10" data-testid={`special-open-${i.id}`}>
                <img src={imgUrl(i.id)} alt={i.title} loading="lazy" className="aspect-[2/3] w-full object-cover transition-transform duration-500 hover:scale-[1.03]" />
              </button>
              <figcaption className="mt-3 flex items-start justify-between gap-2">
                <div><p className="font-display font-semibold">{i.title}</p>{i.caption && <p className="text-xs text-white/60">{i.caption}</p>}</div>
                <ShareButtons item={i} dark />
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-2xl p-2" data-testid="special-lightbox">
          <DialogTitle className="sr-only">{open?.title}</DialogTitle>
          {open && <img src={imgUrl(open.id)} alt={open.title} className="max-h-[85vh] w-full rounded-md object-contain" />}
        </DialogContent>
      </Dialog>
    </section>
  );
};
